import { Relatorio } from '../../models/relatorio-interno/relatorio.model';

export class RelatorioStruct {
  tituloRelatorio: number;
  linkRelatorio: Relatorio;
  listaIdPerfil: number[];
}
